<template>
    <el-row>
        <!-- 修改信息 -->
        <modify-pro-req ref="modifyProReq"></modify-pro-req>
        <add-pro-remark ref="addProRemark"></add-pro-remark>

        <el-table :highlight-current-row="true" :default-sort="{'prop':'status'}" :data="proRequirements">
            <el-table-column width="80" prop="created_username" label="创建人"/>
            <el-table-column width="90" :sort-method="sortByStatus" :sortable="true" prop="status" label="状态">
                <template slot-scope="{row}">
                    <el-tag
                            v-if="row.status === 2"
                            size="mini"
                            type="warning">
                        {{ row.status_display }}
                    </el-tag>

                    <el-tag
                            v-if="row.status === 1"
                            size="mini"
                            type="success">
                        <i class="el-icon-circle-check"></i> {{ row.status_display }}
                    </el-tag>
                    <el-tag
                            v-if="row.status === -1"
                            size="mini"
                            type="info">
                        {{ row.status_display }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column width="170" prop="created_time" label="创建时间"/>
            <el-table-column width="170" prop="finish_time" label="完成时间"/>
            <el-table-column label="标题">
                <template slot-scope="{ row }">
                    <el-popover
                            v-if="row.content"
                            placement="left-start"
                            width="350"
                            trigger="hover"
                            :content="row.content">
                        <el-tag size="mini" slot="reference"><span style="text-decoration:line-through"
                                                                   v-if="row.status=== -1">{{ row.title }}</span> <span
                                v-else>{{ row.title }}</span>
                        </el-tag>
                    </el-popover>
                    <span v-else>
                        <span style="text-decoration:line-through"
                              v-if="row.status=== -1">{{ row.title }}</span> <span
                            v-else>{{ row.title }}</span>
                    </span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="160" label="优先级">
                <template slot-scope="{ row }">
                    <el-rate
                            v-model="row.level"
                            disabled>
                    </el-rate>
                </template>
            </el-table-column>

            <el-table-column width="120" label="备注">
                <template slot-scope="{row}">
                    <pro-remark :pro-requirement="row"></pro-remark>
                </template>
            </el-table-column>
            <el-table-column align="center" width="190" label="功能">
                <template slot-scope="{ row }">
                    <el-button icon="el-icon-edit" :disabled="row.status === 1" @click="modifyClick(row)" type="primary"
                               size="mini">修改
                    </el-button>
                    <el-button :disabled="row.status === 1" @click="addProRemarkClick(row)" type="primary" size="mini">添加备注
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-row>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex'
    import ModifyProReq from "./ModifyProReq"
    import AddProRemark from "./AddProRemark"
    import ProRemark from "./ProRemark"

    export default {
        name: "ProReqTable",
        components: {ProRemark, ModifyProReq,AddProRemark},
        data() {
            return {
                url: `${this.$const.proRequirementUrl}`,
            }
        },
        computed: {

            /**
             * 开发文档修改(组件)
             */
            modifyProReq() {
                return this.$refs.modifyProReq
            },

            /**
             * 添加备注组件
             */
            addProRemark(){
                return this.$refs.addProRemark
            },

            /**
             * 开发文档数组
             */
            proRequirements() {
                return this.ProRequirementData['proRequirements']
            },

            ...mapGetters(['ProRequirementData'])
        },

        methods: {
            modifyClick(row) {
                this.modifyProReq.open(row)
            },

            addProRemarkClick(row) {
                this.addProRemark.open(row)
            },

            /**
             * 通过状态排序
             */
            sortByStatus(a, b) {
                if (a.status !== b.status) {
                    return b.status - a.status
                } else {
                    return b.level - a.level
                }
            },

            /**
             * 加载需求文档
             */
            loadProRequirements() {
                if (this.proRequirements.length <= 0) {
                    this.$getRequest(this.url)
                        .then(response => {
                            this.setProRequirements(response.data)
                        })
                }
            },

            ...mapMutations(['setProRequirements'])
        },
        created() {
            this.loadProRequirements()
        }
    }
</script>

<style scoped>

</style>